import { useMediaQuery } from 'react-responsive';

import { breakpointLargeTablet } from 'app/style/breakpoints';

export const useLargeTabletMediaQuery = (): boolean => useMediaQuery({ minWidth: breakpointLargeTablet });
